
export interface UpdateQueueSinkOperationResult {
    raftCommandIndex: number;
    taskId: number;
}
